import '@fontsource/open-sans/latin-400.css';
// import '@fontsource/open-sans/300.css';
// import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/latin-700.css';
import '@fontsource/raleway/latin-600.css';
import '@fontsource/raleway/latin-900.css';
// import '@fontsource/raleway';
// import '@fontsource/raleway/500.css';
// import '@fontsource/raleway/600.css';
// import '@fontsource/raleway/700.css';

import '@fontsource/dm-sans/latin-300.css';
import '@fontsource/dm-sans/latin-400.css';
import '@fontsource/dm-sans/latin-500.css';
import '@fontsource/dm-sans/latin-600.css';

import './src/styles/global.css';
import { captureLandingPageAttributionFromLocation } from './src/utils/landingPageTracking';

export const onRouteUpdate = ({ location }: { location: { search: string } }) => {
	captureLandingPageAttributionFromLocation(location?.search ?? '');
};
